<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<form #df="ngForm" novalidate (keydown.enter)="getLongFormWebsiteData()" class="formborder">
  <div class="row m-0 col-md-12">
    <div class="col-md-2">
      <span class="required-lable">From Date</span>
      <div class="datepicker_feild">
        <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="DateFrom" [(ngModel)]="DateFrom"
          id="DateFrom" [max]="today" class="form-control input-text-css" required #refDateFrom="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refDateFrom.invalid,
            'alert-warning':
              refDateFrom.invalid &&
              (refDateFrom.dirty ||
                refDateFrom.touched ||
                refDateFrom.untouched)
          }" />

        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>

    <div class="col-md-2">
      <span class="required-lable">To Date</span>
      <div class="datepicker_feild">
        <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="DateTo" [(ngModel)]="DateTo"
          id="DateTo" class="form-control input-text-css" [max]="today" required #refDateTo="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refDateTo.invalid,
            'alert-warning':
              refDateTo.invalid &&
              (refDateTo.dirty || refDateTo.touched || refDateTo.untouched)
          }" />

        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </div>
    </div>
    <div class="col-md-2 p-1">
      <span class="required-lable">Select Status</span>
      <select name="SelectStatus" id="SelectStatus" #refSelectStatus="ngModel" class="form-control input-text-css"
        [(ngModel)]="SelectStatus">
        <option value="">All</option>
        <option value="REJECTED">Reject</option>
        <option value="HOLD">Hold</option>
        <option value="PENDING">Pending</option>
        <option value="IN_PROGRESS">In Process</option>
        <option value="COMPLETED">Completed</option>
      </select>
    </div>
    <div class="col-md-2">
      <button type="button" (click)="getLongFormWebsiteData()" class=" btn font-size-12 button-btn"
        [disabled]="!df.form.valid">
        Search
      </button>
    </div>

    <div class="float-end col-md-4 mt-2" [hidden]="!dataSourceDetail">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch" placeholder="What're you searching for?"
              class="form-control border-0 bg-light" />
            <div class="input-group-append">
              <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</form>

<div [hidden]="!dataSourceDetail" *ngIf="dataSourceDetail" class="mt-3">
  <div class="table-responsive" style="overflow: auto; height: fit-content">
    <table mat-table [dataSource]="dataSourceDetail" class="mat-elevation-z8" matTableExporter
      #exporter="matTableExporter">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="text-center" style="max-width: 3.125rem; width: 3.125rem;">
          #
        </th>
        <td mat-cell *matCellDef="let element; let i = index" class="text-center" style="
            max-width: 3.125rem;
            width: 3.125rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          ">
          {{ (paginatorRef?.pageIndex || 0) * (paginatorRef?.pageSize || 0) + i + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="text-start">Name</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="fatherName">
        <th mat-header-cell *matHeaderCellDef class="text-start">Father Name</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.fatherName }}</td>
      </ng-container>

      <ng-container matColumnDef="mobileNo">
        <th mat-header-cell *matHeaderCellDef class="text-start">Mobile No</th>
        <td mat-cell *matCellDef="let element" class="text-start">
          <a (click)="viewLoanDetail(element)" *ngIf="element.status === 'PENDING' || element.status === 'HOLD'"
            aria-label="true" style="color: blue; cursor: pointer">
            {{ element.mobileNo }}
          </a>
          <span *ngIf="!(element.status === 'PENDING' || element.status === 'HOLD')">
            {{ element.mobileNo }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="IsReloan">
        <th mat-header-cell *matHeaderCellDef class="text-start">Loan Type</th>
        <td mat-cell *matCellDef="let element" class="wrap-address text-start">
          {{ element.reloan ? "Reloan" : "New Loan" }}
        </td>
      </ng-container>


      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef class="text-start">Address</th>
        <td mat-cell *matCellDef="let element" class="wrap-address text-start">
          {{ getFullAddress(element) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="loanAmount">
        <th mat-header-cell *matHeaderCellDef class="text-end">Loan Amount</th>
        <td mat-cell *matCellDef="let element" class="text-end">
          {{ element.loanAmount | currency : "INR" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="text-center">Created At</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          {{ element.createdAt | date:'dd-MM-yyyy HH:mm':'UTC'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef class="text-center">Updated At</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          {{ element.updatedAt | date:'dd-MM-yyyy HH:mm':'UTC'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="text-start">Status</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.status }}</td>
      </ng-container>

      <ng-container matColumnDef="applicationNumber">
        <th mat-header-cell *matHeaderCellDef class="text-start">Application No</th>
        <td mat-cell *matCellDef="let element" class="text-start">
          {{ element.applicationNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="loanAccountNumber">
        <th mat-header-cell *matHeaderCellDef class="text-start">Loan Account No</th>
        <td mat-cell *matCellDef="let element" class="text-start">
          {{ element.loanAccountNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef class="text-start">Reason</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.reason }}</td>
      </ng-container>

      <ng-container matColumnDef="employeeName">
        <th mat-header-cell *matHeaderCellDef class="text-start">Employee Name</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.employeeName }}</td>
      </ng-container>

      <ng-container matColumnDef="utmTerms" *ngIf="hasUtmData">
        <th mat-header-cell *matHeaderCellDef class="text-start">utmTerms</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.utmTerms }}</td>
      </ng-container>
      <ng-container matColumnDef="utmMedium" *ngIf="hasUtmData">
        <th mat-header-cell *matHeaderCellDef class="text-start">utmMedium</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.utmMedium }}</td>
      </ng-container>
      <ng-container matColumnDef="utmSource" *ngIf="hasUtmData">
        <th mat-header-cell *matHeaderCellDef class="text-start">utmSource</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.utmSource }}</td>
      </ng-container>
      <ng-container matColumnDef="utmContent" *ngIf="hasUtmData">
        <th mat-header-cell *matHeaderCellDef class="text-start">utmContent</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.utmContent }}</td>
      </ng-container>
      <ng-container matColumnDef="utmCampaign" *ngIf="hasUtmData">
        <th mat-header-cell *matHeaderCellDef class="text-start">utmCampaign</th>
        <td mat-cell *matCellDef="let element" class="text-start">{{ element.utmCampaign }}</td>
      </ng-container>

      <ng-container matColumnDef="LatLong">
        <th mat-header-cell class="grid-header table-head text-center" *matHeaderCellDef>
          LatLong
        </th>
        <td mat-cell *matCellDef="let row" class="grid-cell text-center">
          <a target="_blank" *ngIf="
              row.LatLong != '' && row.LatLong != null && row.LatLong != ','
            " [href]="'http://maps.google.com/maps?q=' + row.LatLong">
            <i class="fa-solid fa-location-dot"></i>
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="Action">
        <th mat-header-cell class="grid-header j-c-center text-center" *matHeaderCellDef>
          Action
        </th>
        <td mat-cell *matCellDef="let row" class="grid-cell text-center">
          <i *ngIf="row.status === 'PENDING' || row.status === 'HOLD'"
            class="fa fa-arrow-circle-right arrow-circle action-btn" aria-label="true"
            (click)="viewLoanDetail(row)"></i>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedDetailColumns"></tr>
      <tr mat-row [ngClass]="{
          'pending': row.status?.toString()?.trim()?.toUpperCase() === 'PENDING',
          'Hold': row.status?.toString()?.trim()?.toUpperCase() === 'HOLD' || row.status?.toString()?.trim()?.toUpperCase() === 'IN_PROGRESS' || row.status?.toString()?.trim()?.toUpperCase() === 'IN PROGRESS',
          'Reject': row.status?.toString()?.trim()?.toUpperCase() === 'REJECTED' || row.status?.toString()?.trim()?.toUpperCase() === 'REJECT',
          'Completed': row.status?.toString()?.trim()?.toUpperCase() === 'COMPLETED' || row.status?.toString()?.trim()?.toUpperCase() === 'COMPLETE'
        }" *matRowDef="let row; columns: displayedDetailColumns"></tr>
    </table>
  </div>
</div>
<div class="row m-0 ml-3" [hidden]="!dataSourceDetail">
  <div class="col-md-4 mt-3">
    <button class=" btn font-size-12 button-btn" (click)="exportTable()">
      <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
      Export
    </button>
  </div>
  <div class="col-md-8 mt-2">
    <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
<div class="modal fade in" id="loanInNeedModal" tabindex="-1" data-backdrop="false" role="dialog"
  aria-labelledby="myModalLabel" aria-modal="true" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto;">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag class="modal-content" style="border-radius: 0.75rem; overflow: hidden">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Customer Lead Details
        </h6>
        <button type="button" (click)="onClose()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body m-2 p-4" *ngIf="rowData" style="background: #fff">
        <div class="container-fluid formborder">
          <!-- Basic Info -->
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Name</span>
              <div class="font-weight-bold">{{ rowData.name }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Father Name</span>
              <div>{{ rowData.fatherName }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">DOB</span>
              <div>{{ rowData.dob | date : "dd-MM-yyyy" }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Loan Type</span>
              <div>{{ rowData.reloan ? "Reloan" : "New Loan" }}</div>
            </div>
          </div>
          <!-- Contact & ID -->
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Gender</span>
              <div>{{ rowData.gender }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Mobile No</span>
              <div>{{ rowData.mobileNo }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Alternate Mobile No</span>
              <div>{{ rowData.alternateMobileNo }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Email</span>
              <div>{{ rowData.personalEmail }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Work Email</span>
              <div>{{ rowData.officeEmail }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Aadhaar No</span>
              <div>{{ rowData.aadhaarNo }}</div>
            </div>
          </div>
          <!-- Divider -->
          <hr class="my-2" />

          <!-- IDs & Employment -->
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <span class="text-muted small">PAN No</span>
              <div>{{ rowData.panNo }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Income Type</span>
              <div>{{ rowData.incomeType }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Organization</span>
              <div>{{ rowData.organizationName }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Designation</span>
              <div>{{ rowData.designation }}</div>
            </div>
          </div>
          <!-- Financials -->
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Monthly Income</span>
              <div class="font-weight-bold text-success">
                {{ rowData.monthlyIncome | currency : "INR" : "symbol" }}
              </div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Loan Amount</span>
              <div class="font-weight-bold text-primary">
                {{ rowData.loanAmount | currency : "INR" : "symbol" }}
              </div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Loan Period</span>
              <div>{{ rowData.loanPeriod }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">status</span>
              <div>
                <span class="badge" [ngClass]="{
                    'badge-success': rowData.status === 'Approved',
                    'badge-danger': rowData.status === 'Rejected',
                    'badge-warning': rowData.status === 'Pending'
                  }">{{ rowData.status }}</span>
              </div>
            </div>
          </div>
          <!-- Bank Details -->
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <span class="text-muted small">Bank Account No</span>
              <div>{{ rowData.bankAccountNo }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">IFSC Code</span>
              <div>{{ rowData.ifscCode }}</div>
            </div>
            <div class="col-md-4 mb-2">
              <span class="text-muted small">Bank Name</span>
              <div>{{ rowData.bankName }}</div>
            </div>
          </div>
          <hr class="my-2" />
          <!-- UTM Details -->
          <div class="row mb-3" *ngIf="hasUtmData">
            <div class="col-md-3 mb-2">
              <span class="text-muted small">utmTerms</span>
              <div>{{ rowData.utmTerms }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">utmMedium</span>
              <div>{{ rowData.utmMedium }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">utmSource</span>
              <div>{{ rowData.utmSource }}</div>
            </div>
            <div class="col-md-3 mb-2">
              <span class="text-muted small">utmContent</span>
              <div>{{ rowData.utmContent }}</div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="hasUtmData">
            <div class="col-md-3 mb-2">
              <span class="text-muted small">utmCampaign</span>
              <div>{{ rowData.utmCampaign }}</div>
            </div>
          </div>

          <hr class="my-2" *ngIf="hasUtmData" />
          <!-- Address -->
          <div class="row mb-3">
            <div class="col-md-6 mb-2">
              <span class="text-muted small">Address</span>
              <div>
                {{ rowData.address1 }}, {{ rowData.address2 }},
                <span *ngIf="rowData.landmark">{{ rowData.landmark }},</span>
                {{ rowData.area }}, {{ rowData.district }}, {{ rowData.state }},
                {{ rowData.pinCode }}
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <span class="text-muted small">LatLong</span>
              <div>
                <a target="_blank" *ngIf="
                    rowData.LatLong != '' &&
                    rowData.LatLong != null &&
                    rowData.LatLong != ','
                  " [href]="'http://maps.google.com/maps?q=' + rowData.LatLong">
                  <i class="fa-solid fa-location-dot"></i>
                </a>
              </div>
            </div>
          </div>
          <!-- Documents -->
          <!-- Document Table -->
          <div class="mt-3">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Document Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <!-- Profile -->
                <tr *ngIf="profileimageName">
                  <td>Profile Picture</td>
                  <td>
                    <button class="btn btn-link"
                      (click)="openDocModal('Profile Picture', base64Contentprofileimage, profileimageName)">
                      View
                    </button>
                  </td>
                </tr>

                <!-- Aadhaar Front -->
                <tr *ngIf="aadharFrontImageName">
                  <td>Aadhaar Front</td>
                  <td>
                    <button class="btn btn-link"
                      (click)="openDocModal('Aadhaar Front', base64ContentAadharFront, aadharFrontImageName)">
                      View
                    </button>
                  </td>
                </tr>

                <!-- Aadhaar Back -->
                <tr *ngIf="aadharBackImageName">
                  <td>Aadhaar Back</td>
                  <td>
                    <button class="btn btn-link"
                      (click)="openDocModal('Aadhaar Back', base64ContentAadharBack, aadharBackImageName)">
                      View
                    </button>
                  </td>
                </tr>

                <!-- PAN -->
                <tr *ngIf="panCardImageName">
                  <td>PAN Card</td>
                  <td>
                    <button class="btn btn-link"
                      (click)="openDocModal('PAN Card', base64ContentPanCard, panCardImageName)">
                      View
                    </button>
                  </td>
                </tr>

                <!-- Employment Proof -->
                <tr *ngIf="EmploymentProofDocumentImageName">
                  <td>Employment Proof</td>
                  <td>
                    <button class="btn btn-link"
                      (click)="openDocModal('Employment Proof', base64ContentEmploymentProofDocument, EmploymentProofDocumentImageName)">
                      View
                    </button>
                  </td>
                </tr>

                <!-- Bank Statement -->
                <tr *ngIf="BankStatementImageName">
                  <td>Bank Statement</td>
                  <td>
                    <button class="btn btn-link"
                      (click)="openDocModal('Bank Statement', base64ContentBankStatement, BankStatementImageName)">
                      View
                    </button>
                  </td>
                </tr>

                <!-- Salary Slips -->
                <ng-container *ngIf="salarySlipFiles?.length > 0">
                  <tr *ngFor="let slip of salarySlipFiles">
                    <ng-container *ngIf="slip?.salaryfileName && slip?.salarybase64">
                      <td>Salary Slip</td>
                      <td>
                        <button class="btn btn-link"
                          (click)="openDocModal('Salary Slip', slip.salarybase64, slip.salaryfileName)">
                          View
                        </button>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>

                <!-- Address Documents -->
                <ng-container *ngIf="addressDocumentFiles?.length > 0">
                  <tr *ngFor="let address of addressDocumentFiles">
                    <ng-container *ngIf="address?.addressDocumentfileName && address?.addressDocumentbase64">
                      <td>Address Document</td>
                      <td>
                        <button class="btn btn-link"
                          (click)="openDocModal('Address Document', address.addressDocumentbase64, address.addressDocumentfileName)">
                          View
                        </button>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>

                <!-- ✅ NO DOCUMENTS ROW -->
                <tr *ngIf="!hasAnyDocuments()">
                  <td colspan="2" class="text-center text-muted py-4">
                    <div class="d-flex flex-column align-items-center">
                      <i class="fa fa-file-o fa-2x mb-2"></i>
                      <div class="font-weight-bold">No documents uploaded</div>
                      <small>Please upload documents to view here</small>
                    </div>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>

          <!-- Audit -->
          <div class="row">
            <div class="col-md-6 mb-2">
              <span class="text-muted small">Created At</span>
              <div>{{ rowData.createdAt | date : 'dd-MM-yyyy hh:mm a': 'UTC' }}</div>
            </div>
            <div class="col-md-6 mb-2">
              <span class="text-muted small">Updated At</span>
              <div>{{ rowData.updatedAt | date:'dd-MM-yyyy hh:mm a':'UTC' }}</div>
            </div>
          </div>
        </div>
        <div class="mt-2" [hidden]="!dataSourceAadharPan">
          <div class="table-responsive" style="overflow: auto">
            <table mat-table [dataSource]="dataSourceAadharPan" class="modalTable" matTableExporter
              #exporter="matTableExporter">
              <!-- <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      {{ i + 1 }}
                    </td>
                  </ng-container> -->

              <ng-container matColumnDef="customerName">
                <th mat-header-cell *matHeaderCellDef class="text-start" style="width: 25% !important; color: blue">
                  Customer Name
                </th>
                <td mat-cell *matCellDef="let element" class="text-start">
                  {{ element.customerName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Adhaarno">
                <th mat-header-cell *matHeaderCellDef class="text-start" style="width: 20% !important; color: blue">
                  Aadhar No
                </th>
                <td mat-cell *matCellDef="let element" class="text-start">
                  {{ element.Adhaarno }}
                </td>
              </ng-container>

              <ng-container matColumnDef="PanNo">
                <th mat-header-cell *matHeaderCellDef class="text-start" style="width: 20% !important">
                  Pan No
                </th>
                <td mat-cell *matCellDef="let element" class="text-start">
                  {{ element.PanNo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Address">
                <th mat-header-cell *matHeaderCellDef class="text-start" style="width: 35% !important">
                  Address
                </th>
                <td mat-cell *matCellDef="let element" class="text-start">
                  {{ element.Address }}
                </td>
              </ng-container>

              <ng-container matColumnDef="radio">
                <th mat-header-cell class="grid-header j-c-center" *matHeaderCellDef style="width: 5% !important">
                  Select
                </th>
                <td mat-cell *matCellDef="let row" class="grid-cell text-center">
                  <input type="radio" class="form-check-input" name="selectedRowRadio" *ngIf="!row.IsExists_Customer"
                    [checked]="selectedRow && (selectedRow === row || selectedRow.CustomerId === row.CustomerId)"
                    (click)="onRadioChange(row)" />
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsPanAadhar"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsPanAadhar"></tr>
            </table>
          </div>
          <div style="color: red">{{ ExistLoan }}</div>
        </div>
        <form #rf="ngForm" novalidate>
          <div class="formborder" *ngIf="showFinancialDetails">
            <div class="col-md-12 p-1 bg-success1">Loan Financial Details:</div>

            <div class="row m-0 col-md-12 p-1">
              <div class="col-md-3 p-1">
                <span class="required-lable"> Branch </span>
                <select (change)="getAreaByBranch($event.target.value)" name="Branch_Id" id="Branch_Id"
                  (change)="resetInterstValue(null)" #refBranch_Id="ngModel" required [ngClass]="{
                    'is-invalid': rf.submitted && refBranch_Id.invalid,
                    'alert-warning':
                      refBranch_Id.invalid &&
                      (refBranch_Id.dirty ||
                        refBranch_Id.touched ||
                        refBranch_Id.untouched)
                  }" [(ngModel)]="Branch_Id" class="form-control input-text-css">
                  <option value="">Select Branch</option>
                  <option *ngFor="let branch of BranchesList" [value]="branch.BranchId">
                    {{ branch.Branch_Name }}
                  </option>
                </select>
              </div>

              <div class="col-md-3 p-1">
                <span class="required-lable"> Loan Product </span>

                <select name="LoanProduct_Id" id="LoanProduct_Id" (change)="changeLoanProduct()"
                  #refLoanProduct_Id="ngModel" [disabled]="!IsWebsiteFrequencyOpen" required [ngClass]="{
                    'is-invalid': rf.submitted && refLoanProduct_Id.invalid,
                    'alert-warning':
                      refLoanProduct_Id.invalid &&
                      (refLoanProduct_Id.dirty ||
                        refLoanProduct_Id.touched ||
                        refLoanProduct_Id.untouched)
                  }" [(ngModel)]="LoanProduct_Id" class="form-control input-text-css">
                  <option value="">Select Products</option>
                  <ng-container *ngFor="let productg of ProductList">
                    <option [value]="productg.ProductId">
                      {{ productg.Product }}
                    </option>
                  </ng-container>
                </select>
              </div>

              <div class="col-md-3 p-1">
                <span class="required-lable"> Source Area</span>
                <select name="SelectSourceArea" id="SelectSourceArea" (change)="resetInterstValue(null)"
                  #refSelectSourceArea="ngModel" required [ngClass]="{
                    'is-invalid': rf.submitted && refSelectSourceArea.invalid,
                    'alert-warning':
                      refSelectSourceArea.invalid &&
                      (refSelectSourceArea.dirty ||
                        refSelectSourceArea.touched ||
                        refSelectSourceArea.untouched)
                  }" [(ngModel)]="SelectSourceArea" class="form-control input-text-css">
                  <option value="">Select Source Area</option>
                  <ng-container *ngFor="let area of areaData">
                    <option *ngIf="area.Type.trim() == 'Source Area'" [value]="area.Int_Id">
                      {{ area.Area_Name }}
                    </option>
                  </ng-container>
                </select>
              </div>

              <div class="col-md-3 p-1">
                <span class="required-lable"> Required Loan Amount (Rs.) </span>
                <input type="text" [disabled]="IsDisabled" numbersOnly required #refNetFinance_Amt="ngModel"
                  [(ngModel)]="NetFinance_Amt" placeholder="Net Finance" name="NetFinance_Amt" id="NetFinance_Amt"
                  class="form-control input-text-css" [ngClass]="{
                    'is-invalid': rf.submitted && refNetFinance_Amt.invalid,
                    'alert-warning':
                      refNetFinance_Amt.invalid &&
                      (refNetFinance_Amt.dirty ||
                        refNetFinance_Amt.touched ||
                        refNetFinance_Amt.untouched)
                  }" />
              </div>

              <div class="col-md-3 p-1" *ngIf="Category == 'Single Installment'">
                <span class="required-lable">ROI (Per Day) </span>
                <input type="text" appTwoDigitDecimaNumber required #refReducing_ROI="ngModel" [(ngModel)]="ROI"
                  (change)="resetInterstValue(ROI)" placeholder="Reducing_ROI" name="Reducing_ROI" id="Reducing_ROI"
                  class="form-control input-text-css" [ngClass]="{
                    'is-invalid': rf.submitted && refReducing_ROI.invalid,
                    'alert-warning':
                      refReducing_ROI.invalid &&
                      (refReducing_ROI.dirty ||
                        refReducing_ROI.touched ||
                        refReducing_ROI.untouched)
                  }" />
              </div>

              <div class="col-md-3 p-1" *ngIf="Category == 'Single Installment'">
                <span class="required-lable">Loan Date</span>
                <div class="datepicker_feild">
                  <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="Loan_Date" id="Loan_Date"
                    (dateChange)="changeLoan_Date()" required [min]="minDate" #refLoan_Date="ngModel"
                    [disabled]="isDisabled" class="form-control input-text-css" [(ngModel)]="Loan_Date" [ngClass]="{
                      'is-invalid': rf.submitted && refLoan_Date.invalid,
                      'alert-warning':
                        refLoan_Date.invalid &&
                        (refLoan_Date.dirty ||
                          refLoan_Date.touched ||
                          refLoan_Date.untouched)
                    }" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
              <!-- <div class="col-md-3 p-1" *ngIf="Category == 'Single Installment'">
                <span class="required-lable">Loan Maturity Date</span>
                <div class="datepicker_feild">
                  <input [matDatepicker]="picker1" [min]="minLoanMaturityDate" dateConvert
                    (dateChange)="DaysDifference()" name="LoanMaturityDate" id="LoanMaturityDate" required
                    placeholder="DD/MM/YYYY" #refLoanMaturityDate="ngModel" [disabled]="isDisabled" [ngClass]="{
                      'is-invalid': rf.submitted && refLoanMaturityDate.invalid,
                      'alert-warning':
                        refLoanMaturityDate.invalid &&
                        (refLoanMaturityDate.dirty ||
                          refLoanMaturityDate.touched ||
                          refLoanMaturityDate.untouched)
                    }" class="form-control input-text-css" [(ngModel)]="LoanMaturityDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </div>
              </div> -->
              <div class="col-md-3 p-1" *ngIf="Category == 'Single Installment'">
                <span class="required-lable">Loan Maturity Date</span>
                <div class="datepicker_feild">
                  <input [matDatepicker]="picker1" [min]="minLoanMaturityDate" dateConvert
                    (dateChange)="DaysDifference()" name="LoanMaturityDate" id="LoanMaturityDate" required
                    placeholder="DD/MM/YYYY" #refLoanMaturityDate="ngModel" [disabled]="isDisabled" [ngClass]="{
        'is-invalid': (rf.submitted && refLoanMaturityDate.invalid) || isMaturityDateInvalid,
        'alert-warning':
          refLoanMaturityDate.invalid &&
          (refLoanMaturityDate.dirty ||
            refLoanMaturityDate.touched ||
            refLoanMaturityDate.untouched)
      }" class="form-control input-text-css" [(ngModel)]="LoanMaturityDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </div>
                <small class="text-danger" *ngIf="isMaturityDateInvalid">
                  Maturity date must be after loan date.
                </small>
              </div>

              <div class="col-md-3 p-1" *ngIf="Category == 'Single Installment'">
                <span class="required-lable"> Days </span>
                <input type="text" disabled numbersOnly required #refDays="ngModel" [(ngModel)]="Days"
                  placeholder="Days" name="Days" id="Days" class="form-control input-text-css" [ngClass]="{
                    'is-invalid': rf.submitted && refDays.invalid,
                    'alert-warning':
                      refDays.invalid &&
                      (refDays.dirty || refDays.touched || refDays.untouched)
                  }" />
              </div>
              <div class="col-md-12 mt-3 text-center" *ngIf="Category == 'Single Installment'">
                <button *ngIf="showFinancialDetails" type="button" [disabled]="!rf.form.valid" (click)="Calculate()"
                  class="btn font-size-12 button-btn">
                  Calculate
                </button>
              </div>
            </div>

            <div class="row m-0 col-md-12 p-1">
              <div class="col-md-3 p-1" *ngIf="Category == 'Single Installment'">
                <span class="required-lable"> Interest Amount </span>
                <input type="text" disabled numbersOnly required #refInterestAmount="ngModel"
                  [(ngModel)]="InterestAmount" placeholder="InterestAmount" name="InterestAmount" id="InterestAmount"
                  class="form-control input-text-css" [ngClass]="{
                    'is-invalid': rf.submitted && refInterestAmount.invalid,
                    'alert-warning':
                      refInterestAmount.invalid &&
                      (refInterestAmount.dirty ||
                        refInterestAmount.touched ||
                        refInterestAmount.untouched)
                  }" />
              </div>
              <div class="col-md-3 p-1" *ngIf="Category == 'Single Installment'">
                <span class="required-lable"> Agreement Amount </span>
                <input type="text" disabled numbersOnly required #refAgreementAmount="ngModel"
                  [(ngModel)]="AgreementAmount" placeholder="AgreementAmount" name="AgreementAmount"
                  id="AgreementAmount" class="form-control input-text-css" [ngClass]="{
                    'is-invalid': rf.submitted && refAgreementAmount.invalid,
                    'alert-warning':
                      refAgreementAmount.invalid &&
                      (refAgreementAmount.dirty ||
                        refAgreementAmount.touched ||
                        refAgreementAmount.untouched)
                  }" />
              </div>
              <div class="col-md-3 mt-3 text-center">
                <button type="button" [disabled]="!rf.form.valid" *ngIf="
                    Category != 'Single Installment' ||
                    (Category == 'Single Installment' &&
                      AgreementAmount &&
                      InterestAmount)
                  " (click)="SaveApplication()" class="btn font-size-12 button-btn">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
        <div class="formborder" *ngIf="!showFinancialDetails">
          <div class="row m-0 p-2 justify-content-end align-items-center" style="gap: 0.625rem !important;">
            <button type="button" (click)="proceedLoan()" class="btn font-size-12 button-btn"
              [disabled]="!selectedRow && dataSourceAadharPan">
              Proceed
            </button>

            <button type="button" *ngIf="rowData?.status != 'HOLD'" (click)="rejectHoldReasonModel('HOLD', rowData)"
              class="btn font-size-12 button-btn">
              Hold
            </button>

            <button type="button" (click)="rejectHoldReasonModel('REJECTED', rowData)"
              class="btn font-size-12 button-btn">
              Reject
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade in" id="RejectHoldReason" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-s modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          {{ ReasonStatus }}
        </h6>
        <button type="button" (click)="onCloseRejectHold()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>

      <form #rfr="ngForm" novalidate>
        <div class="modal-body">
          <div class="row m-0 col-md-12 p-1">
            <div class="col-md-8 p-1">
              <span class="required-lable"> {{ ReasonStatus }} Reason </span>
              <input type="text" required #refReason="ngModel" [(ngModel)]="Reason" placeholder="Reason" name="Reason"
                id="Reason" class="form-control input-text-css" [ngClass]="{
                  'is-invalid': rfr.submitted && refReason.invalid,
                  'alert-warning':
                    refReason.invalid &&
                    (refReason.dirty ||
                      refReason.touched ||
                      refReason.untouched)
                }" />
            </div>
            <div class="col-md-4 mt-3 text-center">
              <button type="button" [disabled]="!rfr.form.valid" (click)="rejectHoldLoan()"
                class="btn font-size-12 button-btn">
                {{ ReasonStatus }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Document View Modal -->
<div class="modal fade in" id="docViewModal" tabindex="-1" role="dialog" data-backdrop="false"
  aria-labelledby="docViewModalLabel" aria-hidden="true" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content" style="border-radius: 0.75rem">
      <div class="modal-header">
        <h6 class="modal-title" id="docViewModalLabel">{{ docModalTitle }}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDocModal()">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body text-center" style="min-height: 12.5rem;">
        <!-- Show image if not PDF -->
        <img *ngIf="docModalType === 'image' && docModalBase64"
          [src]="'data:' + docModalMime + ';base64,' + docModalBase64" [alt]="docModalFileName" style="
            max-width: 100%;
            max-height: 75vh;
            border-radius: 0.5rem;
            box-shadow: 0 2px 0.75rem rgba(0, 0, 0, 0.15);
          " />
        <!-- Show PDF if PDF -->
        <ng-container *ngIf="docModalType === 'pdf' && docModalBase64">
          <div class="mb-3 d-flex justify-content-between align-items-center bg-light p-2 rounded">
            <span class="text-truncate small pr-2 font-weight-bold">{{ docModalFileName }}</span>
            <a [href]="pdfSrc" target="_blank" class="btn btn-sm button-btn font-size-12">
              <i class="fa fa-external-link-alt mr-1"></i> Open in New Tab
            </a>
          </div>
          <iframe *ngIf="pdfSrc" [src]="pdfSrc" style="
              width: 100%;
              height: 75vh;
              min-height: 550px;
              border-radius: 0.5rem;
              box-shadow: 0 2px 0.75rem rgba(0, 0, 0, 0.15);
              border: 1px solid #ddd;
            "></iframe>
          <div *ngIf="!pdfSrc" class="p-5 text-muted">
            <i class="fa fa-spinner fa-spin fa-2x mb-2"></i>
            <div>Preparing PDF...</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>